<p class="vue-detail-content-wrapper"><ng-content></ng-content></p>
